import { MediaType } from "@/modules/common/media/mediaTypes"
import { word } from "@modules/core/utils/i18n"
import { has } from "lodash"
import * as Yup from "yup"
import { z } from "zod"

export const mediaBlockItemFormSchema = z
  .object({
    id: z.string().nullable(),
    url: z.string().nullable(),
    file: z.custom<File>().nullable(),
    awsS3Key: z.string().nullable(),
    type: z.enum(MediaType),
    isUploading: z.boolean(),
    filename: z.string().nullable(),
  })
  .meta({ id: "mediaBlockItemFormSchema" })
  .refine((media) => media.url != null || media.file != null, {
    message: word("sessionForm.blocks.add_media.missing_error"),
  })

export type MediaBlockItemFormikType = z.infer<typeof mediaBlockItemFormSchema>
export type MediaBlockFormikType = { medias: MediaBlockItemFormikType[] }

export function getMediaBlockItemValidationSchema() {
  return Yup.object()
    .shape({
      url: Yup.string().nullable(),
      file: Yup.mixed().nullable(),
    })
    .test(
      "Youtube URL or Video File",
      word("sessionForm.blocks.add_media.missing_error"),
      (value) => has(value, "url") || has(value, "file"),
    )
}

export function getMediaBlockValidationSchema() {
  return Yup.object().shape({
    medias: Yup.array()
      .of(getMediaBlockItemValidationSchema())
      .test("", word("sessionForm.blocks.add_media.wrong_quantity_of_media"), (value) => {
        return value && value.length > 0 && value.length <= 5
      }),
  })
}

export const mediaBlockFormSchema = z.object({
  medias: z.array(mediaBlockItemFormSchema).refine((medias) => medias.length > 0 && medias.length <= 5, {
    message: word("sessionForm.blocks.add_media.wrong_quantity_of_media"),
  }),
})

export type MediaBlockFormType = z.infer<typeof mediaBlockFormSchema>
